import { Expose, Transform } from 'class-transformer';
import { DrupalIdentifier, DrupalNode } from '@nx-icilalune/drupal-types';

export class Solution extends DrupalNode {
  public static readonly type = 'solutions';

  @Transform(({ obj }) => {
    return obj?.attributes?.summary;
  })
  @Expose()
  override summary!: string;

  @Transform(({ obj }) => {
    return obj?.attributes?.external_links?.uri;
  })
  @Expose()
  link!: string;

  @Transform(({ obj }) => {
    return obj?.relationships?.logo?.data || undefined;
  })
  @Expose()
  logo: DrupalIdentifier | undefined;

  @Transform(({ obj }) => {
    return obj?.relationships?.media?.data || undefined;
  })
  @Expose()
  media!: DrupalIdentifier[] | undefined;

  @Transform(({ obj }) => {
    return obj?.relationships?.paragraphs?.data || undefined;
  })
  @Expose()
  paragraphs!: DrupalIdentifier[] | undefined;

  @Transform(({ obj }) => {
    return obj?.relationships?.associated_projects?.data || undefined;
  })
  @Expose()
  associated!: DrupalIdentifier[] | undefined;
}
